/**
 * Text formatting utilities.
 */

/**
 * Capitalize the first letter of each word, leaving the rest unchanged.
 *
 * Unlike CSS `text-transform: capitalize` or aggressive title-case, this
 * preserves existing casing within words (e.g., "VIP" stays "VIP").
 *
 * @example
 * toTitleCase('my category')   // "My Category"
 * toTitleCase('VIP')           // "VIP"
 * toTitleCase('uncategorized') // "Uncategorized"
 * toTitleCase('new lead')      // "New Lead"
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Format file size in bytes to a human-readable string.
 */
/**
 * Get display initials from a name string.
 * Returns first letter of first two words, or first two chars if single word.
 */
export function getInitials(name: string | undefined | null): string {
  if (!name) return '??';
  const parts = name.split(' ').filter(Boolean);
  if (parts.length >= 2 && parts[0] && parts[1]) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

/**
 * Format file size in bytes to a human-readable string.
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}
